export default {"src":"/_next/static/media/IsLive.0dfba453.svg","height":18,"width":27,"blurWidth":0,"blurHeight":0};